export default "__VITE_ASSET__1UZaGi0f__"